import React, { useContext } from 'react';
import Switch from '@material-ui/core/Switch';
import { Link } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

import { useLocation, useHistory } from 'react-router-dom';

import {
  ProSidebar,
  Menu,
  MenuItem,
  // SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';

import senslaLogo from 'assets/images/sensla-logo.png';
import senslaLogoShort from 'assets/images/sensla-logo-short.png';
// import SenslaLogo from 'assets/images/sensla-logo-dark-bg.svg';
// import SenslaLogoShort from 'assets/images/sensla-logo-short-dark-bg.svg';
// import team from 'assets/images/team.png';
// import hashtag from 'assets/images/hashtag.png';
import pillar from 'assets/images/ancient-pillar.png';
import book from 'assets/images/book.png';
import contact from 'assets/images/contact.png';
import clipboard from 'assets/images/clipboard.png';
import logout from 'assets/images/logout.png';
import pillars from 'assets/images/pillars.png';
import realTime from 'assets/images/real-time.png';
import report from 'assets/images/report.png';
import day from 'assets/images/24-hours.png';
import tab from 'assets/images/tab.png';
import msLogo from 'assets/images/microsoft-teams.svg';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

interface IProps {
  collapsed: boolean;
  rtl: boolean;
  handleToggleSidebar: any;
  toggled: boolean;
  handleCollapsedChange: (checked: boolean) => void;
}

export const Sidebar: React.FC<IProps> = ({
  collapsed,
  handleCollapsedChange,
  handleToggleSidebar,
  rtl,
  toggled,
}) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const history = useHistory();
  const {
    teams: { currentTeam },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);

  const logoutAction = async () => {
    await ((actions.auth.logout() as unknown) as Promise<IStore>);
    history.push('/');
  };

  return (
    <ProSidebar
      rtl={rtl}
      collapsed={collapsed}
      breakPoint="md"
      onToggle={handleToggleSidebar}
      className={classes.sidebar}
      toggled={toggled}
    >
      <SidebarHeader className={classes.headerSideBar}>
        <div className={classes.logoContainer}>
          <img
            alt="sensla logo"
            src={!collapsed ? senslaLogo : senslaLogoShort}
            className={!collapsed ? classes.senslaLogo : classes.senslaLogoShort}
          />
        </div>
      </SidebarHeader>

      <SidebarContent>
        <Menu iconShape="circle" className={classes.content}>
          <div className={classes.top}>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/pillars')}
              icon={<img alt="sensla pillars" src={pillars} className={classes.image} />}
            >
              {!collapsed ? 'Overview' : ''}
              <Link to="/dashboard/pillars" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/pillars-report')}
              icon={<img alt="sensla pillars" src={pillar} className={classes.image} />}
            >
              {!collapsed ? 'Pillars Details' : ''}
              <Link to="/dashboard/pillars-report" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/surveys-report')}
              icon={<img alt="sensla dashboard" src={clipboard} className={classes.image} />}
            >
              {!collapsed ? 'Surveys Responses' : ''}
              <Link to="/dashboard/surveys-report" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/summary')}
              icon={<img alt="sensla summary" src={day} className={classes.image} />}
            >
              {!collapsed ? '24 Hours Summary' : ''}
              <Link to="/dashboard/summary" />
            </MenuItem>
            {/* <MenuItem
              className="no-translate"
              active={pathname === '/dashboard'}
              icon={<img alt="sensla dashboard" src={realTime} className={classes.image} />}
            >
              {!collapsed ? 'Real Time' : ''}
              <Link to="/dashboard/realtime" />
            </MenuItem> */}
            {/* <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/channel')}
              icon={<img alt="sensla " src={hashtag} className={classes.image} />}
            >
              {!collapsed ? 'Channel Real Time' : ''}
              <Link to="/dashboard/channel" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/member')}
              icon={<img alt="sensla " src={contact} className={classes.image} />}
            >
              {!collapsed ? 'User Real Time' : ''}
              <Link to="/dashboard/member" />
            </MenuItem> */}
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/reports')}
              icon={<img alt="sensla reports" src={report} className={classes.image} />}
            >
              {!collapsed ? 'Channels Report' : ''}
              <Link to="/dashboard/reports" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/member')}
              icon={<img alt="sensla member" src={contact} className={classes.image} />}
            >
              {!collapsed ? 'Members Report' : ''}
              <Link to="/dashboard/member" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/dashboard/logs')}
              icon={<img alt="sensla logs" src={realTime} className={classes.image} />}
            >
              {!collapsed ? 'Logs' : ''}
              <Link to="/dashboard/logs" />
            </MenuItem>
          </div>
          <div className={classes.bottom}>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/library')}
              icon={<img alt="sensla resources" src={book} className={classes.image} />}
            >
              {!collapsed ? 'Library' : ''}
              <Link to="/library" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/home')}
              icon={<img alt="sensla home" src={tab} className={classes.image} />}
            >
              {!collapsed ? 'Switch Team' : ''}
              <Link to="/home" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/home')}
              icon={
                currentTeam.teamId ? (
                  <img alt="sensla home" src={currentTeam.avatar} className={classes.imageCt} />
                ) : (
                  <img alt="sensla home" src={msLogo} className={classes.imageCt} />
                )
              }
            >
              {!collapsed ? 'Settings' : ''}
              <Link to="/dashboard/settings" />
            </MenuItem>
            <MenuItem
              className="no-translate"
              active={pathname.includes('/login')}
              icon={
                <img
                  alt="sensla login"
                  src={logout}
                  className={classes.image}
                  onClick={logoutAction}
                />
              }
            >
              {!collapsed ? <span onClick={logoutAction}>Logout</span> : ''}
            </MenuItem>
          </div>
        </Menu>
      </SidebarContent>

      <SidebarFooter className={classes.footerSideBar}>
        <FormControlLabel
          control={<Switch onChange={() => handleCollapsedChange(!collapsed)} color={'primary'} />}
          label={
            !collapsed ? <Typography className={classes.formControlLabel}>Opened</Typography> : null
          }
          color="white"
          className={classes.collapsed}
        />
      </SidebarFooter>
    </ProSidebar>
  );
};
